// Right-column "not available" empty state, shared by ServiceDetail (services
// without a flow) and FinanceServiceFlow (flow services with no SIGNED
// contracts). `image` is optional — provided later.
const ServiceEmptyState = ({ emptyState, isArabic, image = null }) => {
  const title = isArabic ? emptyState?.titleAr : emptyState?.titleEn;
  const sub = isArabic ? emptyState?.subAr : emptyState?.subEn;

  return (
    <div className="flex flex-col items-center justify-center text-center h-full min-h-[280px] px-4 py-10">
      {/* Illustration placeholder — provided later; pass `image` to render. */}
      {image ? <img src={image} alt="" className="w-64 md:w-80 mb-6" /> : null}
      <h2 className="text-2xl md:text-3xl font-bold text-[#1F1F1F] mb-3">{title}</h2>
      <p className="text-[#8E9196] text-sm md:text-base max-w-md">{sub}</p>
    </div>
  );
};

export default ServiceEmptyState;
